// src/services/restaurantConstraintService.js
// 公司層級「特殊日期 / 公休」— admin REST 客戶端（Plan 094 Phase 2）
//
// Backend 路徑：/api/restaurant/constraints[/:id][/toggle] + /weekly-closures
// 回應 shape：list → { success, weeklyClosedDays, specialDates }；其餘 { success, data }
import { apiRequest } from './apiService';

const handle = async (promise, errMsg) => {
  try {
    const response = await promise;
    return response.data; // 後端 body
  } catch (error) {
    throw new Error(error.response?.data?.message || errMsg);
  }
};

const restaurantConstraintService = {
  list: () =>
    handle(apiRequest('get', 'restaurant/constraints'), '無法取得特殊日期 / 公休'),

  // 固定公休（每週）upsert；daysOfWeek=[] → 清除
  setWeeklyClosures: (daysOfWeek) =>
    handle(apiRequest('put', 'restaurant/constraints/weekly-closures', { daysOfWeek }), '設定固定公休失敗'),

  create: (payload) =>
    handle(apiRequest('post', 'restaurant/constraints', payload), '新增特殊日期失敗'),

  update: (id, payload) =>
    handle(apiRequest('put', `restaurant/constraints/${id}`, payload), '更新特殊日期失敗'),

  remove: (id) =>
    handle(apiRequest('delete', `restaurant/constraints/${id}`), '刪除失敗'),

  toggle: (id) =>
    handle(apiRequest('patch', `restaurant/constraints/${id}/toggle`), '切換啟用狀態失敗')
};

export default restaurantConstraintService;
